import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getChatInvite, resetChatInvite } from '../api/chats';
import { ApiError } from '../api/client';
import { backdropClose } from '../lib/modalBackdrop';
import ConfirmModal from './ConfirmModal';

interface Props {
  chatId: string;
  onClose: () => void;
}

function inviteUrl(token: string): string {
  return `${window.location.origin}/join/${token}`;
}

/** Ссылка-приглашение группы: показать, скопировать, сбросить (старая сразу перестаёт работать). */
export default function InviteLinkModal({ chatId, onClose }: Props) {
  const { t } = useTranslation('invites');
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false);

  useEffect(() => {
    getChatInvite(chatId)
      .then((r) => setToken(r.token))
      .catch((e) => setError(e instanceof ApiError ? e.message : t('loadFailed')));
  }, [chatId, t]);

  const copy = async () => {
    if (!token) return;
    try {
      await navigator.clipboard.writeText(inviteUrl(token));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setError(t('copyFailed'));
    }
  };

  const reset = async () => {
    setConfirmReset(false);
    try {
      setToken((await resetChatInvite(chatId)).token);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : t('resetFailed'));
    }
  };

  return (
    <div className="modal-backdrop" {...backdropClose(onClose)}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" title={t('close')} onClick={onClose}>✕</button>
        <h2>{t('title')}</h2>
        {error && <div className="error" style={{ marginBottom: 12 }}>{error}</div>}
        <p style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 8 }}>
          {t('description')}
        </p>
        <input className="input" readOnly value={token ? inviteUrl(token) : '…'} onFocus={(e) => e.currentTarget.select()} />
        <div className="row" style={{ justifyContent: 'space-between', marginTop: 12 }}>
          <button className="btn btn-ghost" onClick={() => setConfirmReset(true)} disabled={!token}>{t('resetLink')}</button>
          <button className="btn" onClick={copy} disabled={!token}>{copied ? t('copied') : t('copy')}</button>
        </div>
      </div>
      {confirmReset && (
        <ConfirmModal
          message={t('resetConfirmation')}
          confirmLabel={t('reset')}
          onConfirm={reset}
          onCancel={() => setConfirmReset(false)}
        />
      )}
    </div>
  );
}
